import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import VittVichaar from "./pages/vitt-vichaar";
import Dhruvtara from "../src/pages/dhruvtara";
import Parinday from "../src/pages/parinday";
import TeamLeo from "./pages/team";

const App = () => {
  return (
    <>
      <div className="min-h-screen">
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vitt-vichaar" element={<VittVichaar />} />
            <Route path="/dhruvtara" element={<Dhruvtara />} />
            <Route path="/parinday" element={<Parinday />} />
            <Route path="/team-leo" element={<TeamLeo />} />
          </Routes>
          <Footer />
        </Router>
      </div>
    </>
  );
};

export default App;
